export default function (action, $form) {
  let extForm = $form.__originalExtForm;
  if(extForm){
    extForm.action = action;
  }
  PF.action[action]($form);
}



// WEBPACK FOOTER //
// ./src/common/components/utils/invokeFormAction.js